export default __webpack_public_path__ + "static/media/VERY-GOOD.a2196498.png";